import authModule from "../../../../utilities/AuthModule";
import { axiosRetryGet } from "../../../../utilities/AxiosRetryUtil";

export class ListItemRepository {
  constructor(protected SiteUrl: string) { }

  public async getListItemsByFilterClause(
    filterText: string,
    listId: string,
    internalColumnName: string,
    keyInternalColumnName?: string,
    webUrl?: string,
    top?: number
  ): Promise<any[]> {
    let returnItems: any[];
    try {
      const webAbsoluteUrl = !webUrl ? this.SiteUrl : webUrl;
      const apiUrl = `${webAbsoluteUrl}/_api/web/lists('${listId}')/items?$select=${keyInternalColumnName ||
        "Id"},${internalColumnName}&$filter=${filterText}&$top=${top}`;

      const accessToken = await authModule.getSharePointAccessToken();
      const result = await axiosRetryGet(apiUrl, {
        headers: { Authorization: `Bearer ${accessToken}` }
      });
      if (result?.data && result?.data.value && result?.data.value.length > 0) {
        return result?.data.value;
      }

      return [];
    } catch (error) {
      return Promise.reject(error);
    }
  }
}
